import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ClientesService } from '../../services/clientes.service';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { EntidadFinancieraService } from '../../services/entidad-financiera.service';

@Component({
  selector: 'app-entidad-financiera-edit',
  templateUrl: './entidad-financiera-edit.component.html',
  styleUrls: ['./entidad-financiera-edit.component.scss']
})
export class EntidadFinancieraEditComponent implements OnInit {

  entidadForm: FormGroup;
  title: string = "Crear";
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
    private _EntidadFinancieraService: EntidadFinancieraService, private _authService: AuthService, private _router: Router,
    public dialogRef: MatDialogRef<EntidadFinancieraEditComponent>,
    private _location: Location) {

    if (this._avRoute.snapshot.params["id"]) {
      this.id = this._avRoute.snapshot.params["id"];
    }

    this.entidadForm = this._fb.group({
      id: 0,
      codigoEntidad: ['', Validators.required],
      nombre: ['', Validators.required],
      grupoBancario: ['', Validators.required],
      activo: [true],
      createdBy: [''],
      updatedBy: [''],
      updatedDate: [''],
      createdDate: [new Date()],
      createdByName: [''],
      updatedByName: ['']
    });

  }

  ngOnInit() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = "Editar";
      this._EntidadFinancieraService.getEntidadesById(this.id)
        .subscribe(resp => {
          this.entidadForm.setValue(resp);
        }
          , error => {
            this.errorMessage = error;
          });
    }
    else {
      this.isNewElement = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal)
      this._location.back();
    else
      this.closeDialog();
  }

  save() {

    if (!this.entidadForm.valid) {
      return;
    }

    if (this.isNewElement) {
      console.log("creando cliente");

      this._EntidadFinancieraService.createEntidad(this.entidadForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
    else {
      this._EntidadFinancieraService.updateEntidad(this.id, this.entidadForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
  }
}
